import { RootState, useSelector } from '../redux/store';
import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DeliveryConfiguration } from '../@types/model/deliveryConfiguration';
import { useEffect, useState } from 'react';

interface DeliveryConfigurationPickerProps {
  deliveryConfigurationGuids: string[] | undefined;
  changeHandler: (deliveryConfigurationGuids: string[] | null) => void;
  deliveryConfigurationAvailable: string[];
  deliveryConfigurations: DeliveryConfiguration[];
}

const DeliveryConfigurationsPicker = (props: DeliveryConfigurationPickerProps) => {
  const { t } = useTranslation();
  const { loaded, deviceTags } = useSelector((state: RootState) => state.user);
  const [deliveryConfigurationFiltered, setDeliveryConfigurationFiltered] = useState<
    DeliveryConfiguration[]
  >([]);

  useEffect(() => {
    if (props.deliveryConfigurationAvailable.length > 0) {
      let deliveryConfigurationFiltered = props.deliveryConfigurations.filter(
        (deliveryConfiguration: DeliveryConfiguration) => {
          if (props.deliveryConfigurationAvailable.includes(deliveryConfiguration.guid))
            return true;
          return false;
        }
      );
      setDeliveryConfigurationFiltered(deliveryConfigurationFiltered);
    } else {
      setDeliveryConfigurationFiltered(props.deliveryConfigurations);
    }
  }, [props.deliveryConfigurationAvailable]);

  if (!loaded) {
    return null;
  }

  return (
    <Autocomplete
      disablePortal
      sx={{ minWidth: '200px' }}
      autoHighlight
      multiple
      value={
        props.deliveryConfigurationGuids
          ? deliveryConfigurationFiltered.filter((dc: DeliveryConfiguration) => {
              return props.deliveryConfigurationGuids?.filter((dcgs: string) => {
                return dcgs === dc.guid;
              }).length;
            })
          : undefined
      }
      options={deliveryConfigurationFiltered}
      onChange={(event, values) => {
        let guids = [];

        props.changeHandler(
          values.map((dc: DeliveryConfiguration) => {
            return dc.guid;
          })
        );
      }}
      getOptionLabel={(option) => {
        return option.configuration.name;
      }}
      renderOption={(props, option) => (
        <li {...props} key={option.guid}>
          {option.configuration.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('delivery_configuration')}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password'
          }}
        />
      )}
    />
  );
};

export default DeliveryConfigurationsPicker;
